/* global Symbol FEATURE_SPPAGE_SELECT_ONLY_IN_VIEWPORT */
//
// Note: this module depends on src/component/global/polyfill being loaded

// Third-Party imports
import $ from 'jquery';
import _ from 'lodash';

// Local imports
import * as domelement from '../util/domelement.js';
import * as event from '../util/event.js';
import * as flash from '../util/flash.js';
import * as inject from './inject';
import * as region from './regionTemplate.js';
import { scroll_with_header } from '../util/animation.js';
import * as string from '../util/string.js';
import * as tocart from './tocart.js';
import { postSponsorshipToCart } from '../util/postSponsorship.js';
import { PAGE_VARS, PageKind } from '../page/vars.js';

// ===========================================================================
// Globals
// ===========================================================================

export const EventKind = {
    SlideSelected: Symbol('sp_page.slide_selected'),
};

// ===========================================================================
//
// ===========================================================================

function get_regiontarget() {
    return $('.sponsorPage-regionalContent');
}

function scroll_to_target(global, selector) {
    let block = global.document.querySelector(selector);
    scroll_with_header(global, block, 0, 600);
}

class SelectCard {
    constructor(shared) {
        this.global = shared.global;
        this.callbacks = shared.tocart_callbacks;
        this.page_data = shared.page_data;

        let event_builder = new event.EventBuilder(global, EventKind);
        this.event = event_builder.create_all();

        // Manually create the submit event for submitting sponsorships
        this.submit_spsh_event = new CustomEvent('submit');
    }

    submit_spsh(child_id) {
        let sponsor_form = this.global.document.querySelector(
            '#sponsorbtn-form'
        );

        let doc = this.global.document;
        // let child_id = doc.getElementById('sponsor_data').dataset.childid;
        // Disable the card button
        this.disable_card_button(doc, child_id);

        if (PAGE_VARS.kind !== PageKind.EventsApp) {
            // Update the data value on the child card
            // This will be used to set the region sponsor button to disabled
            this.set_card_in_cart_data(doc, child_id);
            // Add id to in_cart_ids
            this.add_child_id_to_in_cart_divs(doc, child_id);
            // When either of the sponsor me now buttons are clicked
            // we post the kid to the cart using the add to cart popup
            postSponsorshipToCart(this.global, sponsor_form);
        } else {
            sponsor_form.dispatchEvent(this.submit_spsh_event);
        }
    }

    // When the card is clicked, this is called
    run(event) {
        let global = this.global;
        let selected = event.currentTarget;
        let inner_card = selected.querySelector('div.sponsorshipCard-inner');
        let cards_loading = Boolean(
            selected.querySelectorAll('.sponsorshipCard--loading').length
        );
        let targetTagName = event.target.tagName.toLowerCase();
        let targetIsButton = targetTagName === 'button';
        let selectedChild = create_child_obj(selected);

        // If the cards are loading, we return without doing anything
        if (cards_loading) {
            return;
        }

        if (FEATURE_SPPAGE_SELECT_ONLY_IN_VIEWPORT) {
            // Don't do anything with a card if the slide is not selected and
            // the slide is not fully in the viewport
            let selected_cls = 'sponsorshipCard--selected';
            let clicked_is_selected = selected.classList.contains(selected_cls);
            if (
                !clicked_is_selected &&
                !domelement.in_viewport(global, inner_card)
            ) {
                return;
            }
        }

        if (targetIsButton) {
            this.build_and_insert_form(selectedChild);
            this.submit_spsh(selectedChild.child_id);
            let regionButton = global.document.querySelector(
                '#midpage_tocart_btn'
            );
            if (
                regionButton &&
                regionButton.dataset.childId === selectedChild.child_id
            ) {
                this.disable_region_sponsor_button();
            }
        } else {
            // Toggles the card between selected or not selected
            // and returns TRUE if the card is now selected, and false if not
            let is_selected = toggleSelectedClass(global, selected);
            // Clear/remove the region section if we deselected a card
            if (!is_selected) {
                clearRegion();
            }

            // Clear flash div
            flash.hide();
            flash.clear();

            if (is_selected) {
                // Trigger SlideSelected event
                // If the card was clicked, and NOT the button, we fire
                // a product clicked event to the data layer
                let data = {
                    slide: selected,
                };
                this.event.get(EventKind.SlideSelected).trigger(data);

                let childCountry = _.snakeCase(selectedChild.country);
                this.build_and_insert_form(selectedChild);

                // If the the element that was clicked was NOT the button
                if (!targetIsButton) {
                    // Fetch the countries from countries endpoint
                    // Then build the region section and inject it into the page
                    fetchCountries(childCountry, countryObject => {
                        this.get_countrydata(selectedChild, countryObject);
                    });
                }
            }
        }
    }

    build_and_insert_form(selectedChild) {
        // Builds the <form>
        let flash_html = tocart.toCartTemplate(
            selectedChild,
            '',
            this.callbacks.build_data_input
        );

        // If we're in the events app, we need to manually submit the form
        // when a sponsor button is pressed, using a callback provided
        // to flash.js
        let flash_content_cb = () => {};
        if (PAGE_VARS.kind === PageKind.EventsApp) {
            flash_content_cb = () => {
                this.callbacks.form_onsubmit(form_event => {
                    // The form needs to be manually submitted as the submit
                    // event is being dispatched manually
                    form_event.currentTarget.submit();
                });
            };
        }
        // Insert the <form> into the flash div
        flash.content(flash_html, 'sponsor', flash_content_cb);

        // Gets any '.js-inject' elements and injects the value onto the page
        // Specifically used for elements in the region template
        // Note: This is also being called in the get_countrydata() when the region
        // section is being built
        inject.initialize(global);
        // Adds 'flash--active' to the flash element that holds the <form>
        flash.show();
    }

    get_countrydata(selected_child, country_object) {
        let global = this.global;
        let lang = global.document.querySelector('body').dataset.lang;
        let htmlString = region.build(
            selected_child,
            country_object,
            lang,
            () => {
                let data = global.document.querySelector('.sponsorship-data');
                let buttonDisabled =
                    selected_child.isInCart === 'true'
                        ? 'button--disabled'
                        : '';
                let buttonLabel =
                    selected_child.isInCart === 'true'
                        ? data.dataset.in_cart_spon_btn
                        : data.dataset.tocartButton;
                let tocart_btn = `
                   <button
                        id="midpage_tocart_btn"
                        class="button ${buttonDisabled}"
                        data-child-id="${selected_child.child_id}"
                    >
                        ${buttonLabel}
                   </button>
                `;
                return tocart_btn;
            }
        );
        get_regiontarget().html(htmlString);

        // Setup midpage_tocart_btn click
        let tocart_midpage_btn = global.document.querySelector(
            '#midpage_tocart_btn'
        );
        tocart_midpage_btn.addEventListener('click', () => {
            if (!tocart_midpage_btn.classList.contains('button--disabled')) {
                // Disable the button and update the label
                this.disable_region_sponsor_button();
                this.submit_spsh(selected_child.child_id);
            }
        });

        inject.initialize(global);
        scroll_to_target(global, '.sponsorPage');
    }

    disable_region_sponsor_button() {
        let regionButton = global.document.querySelector('#midpage_tocart_btn');
        if (
            regionButton &&
            !regionButton.classList.contains('button--disabled')
        ) {
            regionButton.classList.add('button--disabled');
            let data = global.document.querySelector('.sponsorship-data');
            regionButton.innerHTML = data.dataset.in_cart_spon_btn;
        }
    }

    disable_card_button(doc, child_id) {
        let cardButtons = doc.querySelectorAll(
            `[id=card_add_button_${child_id}]`
        );
        for (let cardButton of cardButtons) {
            if (!cardButton.classList.contains('button--disabled')) {
                let data = global.document.querySelector('.sponsorship-data');
                let buttonLabel = data.dataset.in_cart_spon_btn;
                cardButton.innerHTML = buttonLabel;
                cardButton.classList.add('button--disabled');
            }
        }
    }

    set_card_in_cart_data(doc, child_id) {
        // This is a failsafe in case any children are duplicated and are already loaded
        // into the slider. Typically, there should only ever be one child with the child_id
        // which would mean there should only be one element with the id: child_card_child_id,
        // so this is just a safeguard against child sync errors
        let child_cards = doc.querySelectorAll(`[id=child_card_${child_id}]`);
        for (let card of child_cards) {
            card.dataset.isInCart = 'true';
        }
    }

    add_child_id_to_in_cart_divs(doc, child_id) {
        let ids_in_cart_parent = doc.getElementById('child_ids_in_cart');
        let child_id_div = doc.createElement('div');
        child_id_div.setAttribute('id', `cart_child_id_${child_id}`);
        ids_in_cart_parent.appendChild(child_id_div);
    }
}

// shared is an object that contains the following attributes:
//
// * global -- the global object (window when in a browser)
//
// * tocart_callbacks -- callbacks needed to dynamically create the tocart form
//   of any sponsorship page (eg sponsorship home, events app). This form is
//   responsible for adding a sponsorship to a donor's cart.
//
// * page_data -- object containing the following attributes:
//
//    - midpage_cta_datalayer_suffix -- string to suffix event label stored in
//    the datalayer
export function init_slide(shared, slide_node) {
    let card = slide_node.querySelector('.sponsorshipCard');
    if (card === null) {
        return;
    }
    let select_card = new SelectCard(shared);

    let sliderElement = shared.global.document.getElementById(
        'spshhome-slider'
    );
    let sliderWasDragged = sliderElement.dataset.dragState === 'dragging';

    card.addEventListener('click', event => {
        let buttonDisabled = event.target.classList.contains(
            'button--disabled'
        );

        if (!buttonDisabled && !sliderWasDragged) {
            select_card.run(event);
        }
    });

    let learn_more = slide_node.querySelector('.sponsorshipCard-link');
    if (learn_more === null) {
        return;
    }

    // Adding the Enter keypress event and triggering the card click event
    learn_more.addEventListener('keypress', function(event) {
        let buttonDisabled = event.target.classList.contains(
            'button--disabled'
        );

        if (event.which === 13 && !buttonDisabled && !sliderWasDragged) {
            card.click();
        }
    });
}

function toggleSelectedClass(global, card) {
    let selectedClass = 'sponsorshipCard--selected';
    let close_button = card.querySelector('.sponsorshipCard-close');
    let learnMoreLink = card.querySelector('.sponsorshipCard-link');
    if (card.classList.contains(selectedClass)) {
        setTimeout(() => {
            card.classList.remove(selectedClass);
            close_button.style.display = 'none';
            learnMoreLink.setAttribute('aria-expanded', 'false');
        });

        return false;
    } else {
        setTimeout(() => {
            // Find currently selected card and de-select it
            let all_selected = global.document.querySelectorAll(
                `.${selectedClass}`
            );
            for (let selected of all_selected) {
                toggleSelectedClass(global, selected);
            }

            card.classList.add(selectedClass);
            close_button.style.display = 'block';
            learnMoreLink.setAttribute('aria-expanded', 'true');
        });

        return true;
    }
}

function create_child_obj(el) {
    let data = el.dataset;
    let video_link_el = el.querySelector('.sponsorshipCard-videoLink');

    // This cannot use .dataset since video_link_el if it exists is an svg tag,
    // and some older browsers do not support .dataset on it
    let video_link =
        video_link_el === null
            ? null
            : video_link_el.getAttribute('data-video');

    let childobj = {
        variant_id: data.variantId,
        bio: data.bio,
        country: el.querySelector('.sponsorshipCard-country').textContent,
        fave_play: data.play,
        img_url: data.img,
        lang: data.lang,
        min_amount: data.minAmount,
        name: string.titlecase(
            el.querySelector('.sponsorshipCard-name').textContent
        ),
        page_link: data.link,
        price: data.price,
        subject: data.subject,
        age: data.age,
        birth_year: data.birthYear,
        birth_month: data.birthMonth,
        birth_date: data.birthDate,
        gender: data.gender,
        product_id: data.productId,
        child_id: data.childId,
        video_link,
        isInCart: data.isInCart,
        projectid: data.projectid,
        childnumber: data.childnumber,
        firstname: data.firstname,
    };
    return childobj;
}

function fetchCountries(childCountry, cb) {
    let url = '/collections/sponsorships/?view=countries-endpoint';
    $.get(url, response => {
        response = JSON.parse(response);
        let countryObject = response[childCountry];
        cb(countryObject);
    });
}

export function clearRegion() {
    get_regiontarget().html('');
}
